import { Container, Row, Col, Text } from '@qonsoll/react-design'
import { MockupList } from '../../../Mockup/components'
import { useGetOfferMockups } from '../../hooks'
import PropTypes from 'prop-types'
import { Spinner } from 'components'
import { useTranslations } from 'contexts/Translation'

export default function OfferMockups(props) {
  const { offer } = props

  // [ADDITIONAL_HOOKS]
  const [mockups, loading] = useGetOfferMockups(offer)
  const { t } = useTranslations()

  return (
    <Container>
      <Row noGutters>
        <Col>
          {loading ? (
            <Spinner flex={1} />
          ) : mockups?.length ? (
            <MockupList {...props} hideAddCard mockups={mockups} />
          ) : (
            <Text type="secondary" variant="overline">
              {t('No mockups have been added yet')}
            </Text>
          )}
        </Col>
      </Row>
    </Container>
  )
}

OfferMockups.propTypes = {
  offer: PropTypes.object.isRequired
}
